import { isNpsGuide } from '@/vuex/modules/guides/guides.utils';
import get from 'lodash/get';

export function openFeedbackItem (toPath, allFeedbackId, vocItemId) {
    const path = toPath({
        name: 'ValidateFeedbackSavedViewTabs',
        params: { savedviewId: allFeedbackId, tab: 'items' },
        query: { openItem: vocItemId },
    });

    window.open(path);
}

export function createVocItem ({
    initialFormData,
    formDataQuestion,
    guide,
    pollResponseRow,
    status,
    guideProductAreas,
    sourceIdentifier,
    source = 'PollResponse',
}) {
    const { name, appIds } = guide;
    const { visitorId, pollResponse, followUpResponse, url, browserTime } = pollResponseRow;
    const accountIdField = isNpsGuide(guide) ? 'accountId' : 'account.auto.id';
    const accountId = get(pollResponseRow, accountIdField);
    switch (source) {
        case 'PollResponse':
            populatePollResponseFormData(initialFormData, name, pollResponse);
            break;
        case 'NPS':
            populateNPSFormData(initialFormData, name, followUpResponse, pollResponse);
            break;
    }

    return {
        status,
        formData: initialFormData,
        formDataQuestion,
        appIds,
        productAreaIds: guideProductAreas.map((gpa) => gpa.id),
        isPublic: true,
        onBehalfOfType: 'Visitor',
        onBehalfOfId: visitorId,
        accountId,
        type: 'feedback',
        source: {
            sourceCategory: 'PendoUI',
            source,
            sourceIdentifier,
        },
        submittedFromUrl: url,
        createdAt: browserTime,
        strength: 1,
    };
}

function populatePollResponseFormData (initialFormData, name, pollResponse) {
    initialFormData[0].content = `Feedback from ${name}`;
    initialFormData[1].content = `${pollResponse}`;

    if (initialFormData[0].content.length > 256) {
        initialFormData[0].content = `${initialFormData[0].content.slice(0, 253)}...`;
    }
}

function populateNPSFormData (initialFormData, name, followUpResponse, pollResponse) {
    initialFormData[0].content = `Feedback from ${name}`;
    initialFormData[1].content = `${followUpResponse}`;
    initialFormData[2].content = `${pollResponse}`;

    if (initialFormData[0].content.length > 256) {
        initialFormData[0].content = `${initialFormData[0].content.slice(0, 253)}...`;
    }
}

export const onDrawerOpen = () => {
    window.history.pushState({ drawerOpen: true }, '');
};
